import script from "./BlueDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./BlueDrawer.vue?vue&type=script&setup=true&lang=js"

import "./BlueDrawer.vue?vue&type=style&index=0&id=1aa281c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1aa281c4"]])

export default __exports__